/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Delete } from '../fn/ticket-status-mappings/delete';
import { Delete$Params } from '../fn/ticket-status-mappings/delete';
import { Get } from '../fn/ticket-status-mappings/get';
import { Get$Params } from '../fn/ticket-status-mappings/get';
import { List } from '../fn/ticket-status-mappings/list';
import { List$Params } from '../fn/ticket-status-mappings/list';
import { Options } from '../fn/ticket-status-mappings/options';
import { Options$Params } from '../fn/ticket-status-mappings/options';
import { Save } from '../fn/ticket-status-mappings/save';
import { Save$Params } from '../fn/ticket-status-mappings/save';
import { SaveDisplayStatus } from '../fn/ticket-status-mappings/save-display-status';
import { SaveDisplayStatus$Params } from '../fn/ticket-status-mappings/save-display-status';
import { SupportTicketDisplayStatusModel } from '../models/support-ticket-display-status-model';
import { SupportTicketStatusMappingModel } from '../models/support-ticket-status-mapping-model';
import { SupportTicketStatusMappingModelPrimeDatatableResults } from '../models/support-ticket-status-mapping-model-prime-datatable-results';
import { SupportTicketStatusMappingOptionsModel } from '../models/support-ticket-status-mapping-options-model';

@Injectable({ providedIn: 'root' })
export class TicketStatusMappingsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiTicketStatusMappingsListPost()` */
  static readonly ApiTicketStatusMappingsListPostPath = '/api/TicketStatusMappings/List';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `List()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List$Response(params?: List$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketStatusMappingModelPrimeDatatableResults>> {
    return List(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `List$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List(params?: List$Params, context?: HttpContext): Observable<SupportTicketStatusMappingModelPrimeDatatableResults> {
    return this.List$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupportTicketStatusMappingModelPrimeDatatableResults>): SupportTicketStatusMappingModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiTicketStatusMappingsOptionsGet()` */
  static readonly ApiTicketStatusMappingsOptionsGetPath = '/api/TicketStatusMappings/Options';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Options()` instead.
   *
   * This method doesn't expect any request body.
   */
  Options$Response(params?: Options$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketStatusMappingOptionsModel>> {
    return Options(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Options$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  Options(params?: Options$Params, context?: HttpContext): Observable<SupportTicketStatusMappingOptionsModel> {
    return this.Options$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupportTicketStatusMappingOptionsModel>): SupportTicketStatusMappingOptionsModel => r.body)
    );
  }

  /** Path part for operation `apiTicketStatusMappingsGetPost()` */
  static readonly ApiTicketStatusMappingsGetPostPath = '/api/TicketStatusMappings/Get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Get()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get$Response(params?: Get$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketStatusMappingModel>> {
    return Get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Get$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get(params?: Get$Params, context?: HttpContext): Observable<SupportTicketStatusMappingModel> {
    return this.Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupportTicketStatusMappingModel>): SupportTicketStatusMappingModel => r.body)
    );
  }

  /** Path part for operation `apiTicketStatusMappingsSavePost()` */
  static readonly ApiTicketStatusMappingsSavePostPath = '/api/TicketStatusMappings/Save';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Save()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Save$Response(params?: Save$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketStatusMappingModel>> {
    return Save(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Save$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Save(params?: Save$Params, context?: HttpContext): Observable<SupportTicketStatusMappingModel> {
    return this.Save$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupportTicketStatusMappingModel>): SupportTicketStatusMappingModel => r.body)
    );
  }

  /** Path part for operation `apiTicketStatusMappingsSaveDisplayStatusPost()` */
  static readonly ApiTicketStatusMappingsSaveDisplayStatusPostPath = '/api/TicketStatusMappings/SaveDisplayStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveDisplayStatus()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveDisplayStatus$Response(params?: SaveDisplayStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketDisplayStatusModel>> {
    return SaveDisplayStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveDisplayStatus$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveDisplayStatus(params?: SaveDisplayStatus$Params, context?: HttpContext): Observable<SupportTicketDisplayStatusModel> {
    return this.SaveDisplayStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupportTicketDisplayStatusModel>): SupportTicketDisplayStatusModel => r.body)
    );
  }

  /** Path part for operation `apiTicketStatusMappingsDeletePost()` */
  static readonly ApiTicketStatusMappingsDeletePostPath = '/api/TicketStatusMappings/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Delete()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Delete$Response(params?: Delete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return Delete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Delete$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Delete(params?: Delete$Params, context?: HttpContext): Observable<void> {
    return this.Delete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
